export default {
    setWebsocketMessage(context, messages) {
        if (messages);
        context.commit('mutateWebsocketMessage', messages);
    },
}